import { useQuery } from '@tanstack/react-query'
import { fetchCreditBalance } from 'services/contactRequest'

const CREDIT_BALANCE_KEY = 'creditBalance'

interface CreditBalance {
  total: number
  available: number
  used: number
  pending: number
}

const defaultBalance: CreditBalance = {
  total: 0,
  available: 0,
  used: 0,
  pending: 0,
}

export function useCreditBalance(enabled = true) {
  const query = useQuery({
    queryKey: [CREDIT_BALANCE_KEY],
    queryFn: fetchCreditBalance,
    enabled,
    staleTime: 60_000,
  })

  const credits: CreditBalance = query.data?.credits
    ? {
        total: query.data.credits.total ?? 0,
        available: query.data.credits.available ?? 0,
        used: query.data.credits.used ?? 0,
        pending: query.data.credits.pending ?? 0,
      }
    : defaultBalance

  return { credits, isLoading: query.isLoading, refetch: query.refetch }
}
